// extracted by mini-css-extract-plugin
export var container = "_gw-0";
export var outlet = "_gw-1";
export var outletEnter = "_gw-2";
export var outletEnterActive = "_gw-3";
export var outletExit = "_gw-4";
export var outletExitActive = "_gw-5";